/* global swal  angular*/
import './style.less';
import { find, orderBy, findIndex } from 'lodash';

export default function($log, ApiClass, ProfileClass, $stateParams, Swal) {
  'ngInject';

  const vm = this;
  const companyInfo = ProfileClass.profileComplete.company;

  vm.$onInit = activate;
  vm.activate = activate;

  vm.addSession = ({ id, name, start_time, location }) => {
    const externalSession = { id, name, start_time, location, type: 'cnf' };
    vm.updateEvent([...vm.event.externalSessions, externalSession]).then(data =>
      vm.event.externalSessions.push({ id, name, start_time, location, type: 'cnf' })
    );
  };

  vm.removeSession = ({ id }) => {
    const newExternalSessions = [...vm.event.externalSessions];
    const index = findIndex(newExternalSessions, { id });
    newExternalSessions.splice(index, 1);
    vm.updateEvent(newExternalSessions).then(data => (vm.event.externalSessions = newExternalSessions));
  };

  vm.includedSession = ({ id }) => {
    return find(vm.event.externalSessions, { id });
  };

  vm.updateEvent = externalSessions => {
    const params = {
      event_id: vm.event.event_id,
      course_id: vm.event.course_id,
      externalSessions
    };

    return ApiClass.eventsIdPatch({ id: $stateParams.eventid, manage: true }, { event: params })
      .then(({ data: { event } }) => event)
      .then(event => {
        vm.event = { ...vm.event, ...event };
        Swal.toast(`Event updated!`, 'success');
      })
      .catch(error => {
        if (error.message === 'exit') return;
        $log.error(error);
        swal('Error', error, 'error');
        throw error;
      });
  };

  function cnfInit() {
    ApiClass.eventsAssetsCnfGet({}, {}, { queryParams: { manage: true } })
      .then(({ data: { events } }) => {
        vm.rawCnfs = orderBy(events, ['sortTime'], ['asc']);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  function activate() {
    $log.debug('Conferences Editor Component Activated');
    vm.event.externalSessions = vm.event.externalSessions || [];

    ApiClass.companiesIdTypeGet({ manage: true, id: companyInfo.company_id, type: 'integrations' }, null, {})
      .then(({ data: { items } }) => {
        vm.cnfEnabled =
          find(items, {
            integration_id: 'cnf'
          }) && find(items, { integration_id: 'cnf' }).active;
        if (vm.cnfEnabled) cnfInit();
      })
      .catch(error => {
        $log.error(error);
        vm.error = false;
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/conferenceEditor/controller.js